// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"f6535946","208":"7b4ddbcb","592":"02b72713","760":"095eaa59"}[chunkId] + ".chunk.js";
};